export default function ExplanationStep({ title, description }) {
    return (
        <div className="flex flex-col gap-5" style={{ flex: "0 0 256px" }}>
            <h2 className='font-bold text-lg text-secondary'>
                {title}
            </h2>
            <p className='text-sm text-description opacity-60'>
                {description}
            </p>
        </div>
    )
};